import { useState } from "react";
import { faqs } from "@/mocks/home";

export default function FaqSection() {
  const [open, setOpen] = useState<number>(0);

  return (
    <section id="faq" className="bg-background-100/70 py-16 md:py-20">
      <div className="container-site grid grid-cols-1 gap-10 lg:grid-cols-5">
        <div className="lg:col-span-2">
          <span className="text-xs font-bold uppercase tracking-widest text-accent-700">
            FAQ
          </span>
          <h2 className="mt-2 text-2xl font-black text-foreground-950 md:text-4xl">
            关于嗑瓜星球 · 你想知道的都在这里
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            还没想好怎么开始？看看新朋友问得最多的几个问题。玩得开心，也记得理性吃瓜、守住底线。
          </p>
          <a
            href="#hot"
            className="mt-6 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-bold text-background-50 transition hover:bg-accent-600"
          >
            现在就开逛 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="flex flex-col gap-3 lg:col-span-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className="overflow-hidden rounded-xl border border-background-200/70 bg-background-50"
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm font-bold text-foreground-950 md:text-base">
                    <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-100 text-xs font-black text-primary-700">
                      Q
                    </span>
                    {f.q}
                  </span>
                  <i
                    className={`text-xl text-foreground-500 transition-transform duration-300 ${
                      isOpen ? "ri-subtract-line rotate-180" : "ri-add-line"
                    }`}
                  ></i>
                </button>
                {isOpen && (
                  <div className="animate-pop border-t border-background-100 px-5 py-4">
                    <p className="flex items-start gap-3 text-sm leading-relaxed text-foreground-700">
                      <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-accent-100 text-xs font-black text-accent-700">
                        A
                      </span>
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}